import React from 'react';

interface FlikiconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: 'white' | 'black';
}

const Flikicon: React.FC<FlikiconProps> = ({
  width = 20,
  height = 20,
  className = '',
  color = 'black',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 300 256"
      fill={color === 'white' ? 'none' : 'none'}
      className={className}
    >
      <path
        d=""
        stroke={color === 'white' ? 'none' : 'none'}
        fill={color === 'white' ? '#ffffff' : '#000000'}
        fillRule="evenodd"
      />
      <path
        d="M 101 21.384 C 101 22.096, 102.912 24.415, 105.250 26.537 C 107.588 28.658, 113.325 34.096, 118 38.620 C 126.500 46.846, 126.500 46.846, 161.293 52.971 C 180.429 56.339, 196.742 59.347, 197.543 59.655 C 198.344 59.962, 198.999 59.828, 198.998 59.357 C 198.997 58.886, 196.409 57.456, 193.248 56.179 C 179.299 50.548, 133.341 32.384, 121.500 27.822 C 100.772 19.836, 101 19.907, 101 21.384 M 49.515 46.025 C 49.864 46.589, 53.378 48.666, 57.324 50.641 C 61.271 52.617, 73.009 58.760, 83.408 64.292 C 102.316 74.352, 102.316 74.352, 139.908 71.067 C 180.378 67.531, 188.335 66.616, 186 65.764 C 176.636 62.347, 48.116 43.760, 49.515 46.025 M 219.500 72.157 C 214.550 72.645, 188 75.054, 160.500 77.511 C 96.744 83.206, 16 92.933, 16 94.919 C 16 96.360, 18.128 96.761, 144 119.038 C 162.425 122.299, 178.519 125.210, 179.765 125.506 C 183.323 126.353, 194.432 137.933, 197.508 144 C 209.972 168.589, 189.797 188.536, 147.500 193.441 C 120.228 196.605, 119.157 196.602, 122.166 193.366 C 124.771 190.566, 125.620 188.358, 129.995 173 C 133.103 162.094, 139.861 148.770, 147.437 138.616 C 151.082 133.730, 153.938 129.610, 153.783 129.460 C 152.003 127.749, 120.269 123.436, 118.820 124.708 C 105.049 136.800, 101.003 173.998, 111.553 191.518 C 113.639 194.982, 114.376 197, 113.556 197 C 110.370 197, 82.498 200.168, 82.089 200.577 C 79.905 202.762, 116.941 220.307, 139.813 227.922 C 194.830 246.238, 238.848 238.231, 273.178 203.662 C 296.301 180.377, 289.664 123.067, 260.305 92.500 C 252.693 84.575, 232.801 70.738, 229.590 71.135 C 228.991 71.209, 224.450 71.669, 219.500 72.157"
        stroke={color === 'white' ? 'none' : 'none'}
        fill={color === 'white' ? '#ffffff' : '#000000'}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Flikicon;
